/* eslint-disable */
import 'jquery.cookie';
import moment from 'moment';
import 'moment/locale/ru';

import HotelsSortedRepo from '@/js/common/Domain/Repository/HotelsSorted';
import TourCriteriaObjectValue from "@/js/common/Domain/ObjectValue/TourCriteria";

import toRouterHydrator from "@/js/common/Domain/Hydrator/toRouter";
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import ecommerceService from "@/js/common/Domain/Service/ecommerce";
import getMultipleHotelPhotosService from "@/js/common/Domain/Service/getMultipleHotelPhotos";
import {propsDecorator} from "@/js/common/Domain/Service/mixins/decorators";

var filtersValueOld = null,
    filterTitles = [],
    filterRatingValueOld = null,
    filterRatingTitle = null,
    filtersCount = {},
    filterNames = [],
    reviewHtml = '<span class="filterReviewLineDefault"></span><span class="filterReviewLineDefault"></span><span class="filterReviewLineDefault"></span><span class="filterReviewLineDefault"></span><span class="filterReviewLineDefault"></span>',
    isOperatorFiltered = () => {
        return ~window.location.hash.indexOf('&operators=');
    },
    defaultMinPrice = 6000,
    defaultMaxPrice = 10000000;

@propsDecorator({
    hotelsCollection:null,
    defaults: {
        searchData: new TourCriteriaObjectValue(),
        blurToursColumn:false,
        beforeToursLoading: true,
        nothingFoundFormOpened: false,
        showAdditionalFilterCriteria: false,
        loadingState: "loading", //"loading", "asyncLoading", "finished"
        loadingInProgress: false,
        syncHotels: null,
        asyncHotels: null,
        similarHotels: null,
        syncTourProducts: null,
        asyncTourProducts: null,
        pageNumber: 0,
        sortStrategy: "recommend",
        sortStrategyChanged: false,
        priceFilterTipClosed: !!$.cookie('priceFilterTipClosed'),
        viewMode: 'standart',
		scrollPosition: 0,
		tourCriteriaLoaded: false,

        promoBannerShowHot: $.cookie('promoBannerShowHotClosed') !== "true",
        promoBannerShowEarlyBooking: $.cookie('promoBannerEarlyBookingClosed') !== "true",
        promoBannerShowSearchOperator: isOperatorFiltered() && ($.cookie('promoBannerSearchOperatorClosed') !== "true"),



        regionType: null,
        regionWithOffices: null,
        showChildrenFilters: false,

        /*fromComputeds*/
        scoreReviewsLocation: reviewHtml,
        scoreReviewsService: reviewHtml,
        scoreReviewsMeal: reviewHtml,

        ratingLocationMax:5,
        ratingServiceMax:5,
        ratingMealMax:5,

        ratingByLocationCountOverall: 0,
        ratingByServiceCountOverall: 0,
        ratingByMealCountOverall: 0,

        defaultMinPrice:defaultMinPrice,
        defaultMaxPrice:defaultMaxPrice,
        unfilteredMinPrice: defaultMinPrice,
        unfilteredMaxPrice: defaultMaxPrice,
        sliderMinPrice: defaultMinPrice,
        sliderMaxPrice: defaultMaxPrice,
        minPrice: 0,
        maxPrice: 0,
        numOfToursFiltered: 0,
        // empty serp model
        goSearchEmptySerpFoundByAnotherDate: null,
        foundByAnotherDate: null,
        callMeBackBannerVisible: null,
        additionalSearch: null,
        searchByDefaultTourCriteria: null,
        visibleSimilarTours: null,
        //
		showHotelSearchTooltip: null,
		covidBanner: false,
        isDirectFlightAllowed: false,
    },
    computeds: {
        sliderMinPriceFormatted: {
            deps: ['sliderMinPrice'],
            get: function (sliderMinPrice) {
                return sliderMinPrice.formatNumber();
            },
            set: function (value) {
                if (typeof value == 'string') {
                    value = parseInt(value.split(' ').join(''))
                }
                return {
                    sliderMinPrice: value
                }
            }
        },
        sliderMaxPriceFormatted: {
            deps: ['sliderMaxPrice'],
            get: function (sliderMaxPrice) {
                return sliderMaxPrice.formatNumber();
            },
            set: function (value) {
                if (typeof value == 'string') {
                    value = parseInt(value.split(' ').join(''))
                }
                return {
                    sliderMaxPrice: value
                }
            }
        },
        isRegion: function () {
            var departureCity = this.get('searchData').get('departureCity');

            return !!(departureCity && departureCity.get('id') > 2);
        },
        allOperatorsUrl: function () {
            var searchData = this.get('searchData'),
                params,
                url = '';

            if (searchData) {
                params = toRouterHydrator(searchData);
                params.operators = [];
                url = "#?" + $.param(params);
            }

            return url;
        },
        fromMoscowUrl: function () {
            var searchData = this.get('searchData'),
                params,
                url = '';

            if (searchData) {
                params = toRouterHydrator(searchData);
                params.fromCity = 2;
                url = "#?" + $.param(params);
            }

            return url;
        },
        onlyOneHotelSelected: function () {
            var searchData = this.get('searchData'),
                onlyOneHotelSelected = false,
                hotels;

            if (searchData) {
                hotels = searchData.get("hotels");
                if (hotels && hotels.length === 1) {
                    onlyOneHotelSelected = hotels.at(0);
                }
            }

            return onlyOneHotelSelected;
        },
        oneHotelSelectedUrl: function () {
            var oneHotelSelected = this.get('onlyOneHotelSelected'),
                oneHotelSelectedUrl = '';

            if (oneHotelSelected) {
                oneHotelSelectedUrl = '/hotel/' + oneHotelSelected.get('id');
            }

            return oneHotelSelectedUrl;
        },
        oneHotelSelectedName: function () {
            var oneHotelSelected = this.get('onlyOneHotelSelected'),
                oneHotelSelectedName = '';

            if (oneHotelSelected) {
                oneHotelSelectedName = oneHotelSelected.get('name');
            }

            return oneHotelSelectedName;
        },
        promoBannerShowComputed: {
            deps: ["promoBannerShowHot"],
            get: function (promoBannerShowHot) {
                return promoBannerShowHot;
            },
            set: function (value) {
                $.cookie('promoBannerShowHotClosed', !value, {path: '/', expires: 999, domain: 'all'});
                return {
                    promoBannerShowHot: value
                }
            }
        },
        promoBannerEarlyBookingShowComputed: {
            deps: ["promoBannerShowEarlyBooking"],
            get: function (promoBannerShowEarlyBooking) {
                return promoBannerShowEarlyBooking;
            },
            set: function (value) {
                $.cookie('promoBannerEarlyBookingClosed', !value, {path: '/', expires: 999, domain: 'all'});
                return {
                    promoBannerShowEarlyBooking: value
                }
            }
        },
        promoBannerSearchOperatorShowComputed: {
            deps: ["promoBannerShowSearchOperator"],
            get: function (promoBannerShowSearchOperator) {
                return promoBannerShowSearchOperator && isOperatorFiltered();
            },
            set: function (value) {
                $.cookie('promoBannerSearchOperatorClosed', !value, {path: '/', expires: 999, domain: 'all'});
                return {
                    promoBannerShowSearchOperator: value && isOperatorFiltered()
                }
            }
        },
        isHotTours: function () {
            return false;
        },
        changedFiltersPropose: function () {
            var self = this,
                changedFilters = tourCriteriaService.getMaybeWrongFields(this.get('searchData')),
                template = _.template("<li><%= name %></li>"),
                html = $();

            changedFilters = changedFilters.slice(0, 3);

            _.each(changedFilters, (field) => {
                if (field !== 'priceRange') {
                    var view = self.searchFormViewModel.get(field).get('view'),
                        element;

                    if (!_.isEmpty(view) && view.label !== 'бюджет') {
                        element = $(template({name: view.label}));

                        element.on('click', function (e) {
                            view.scrollToElement(e);
                        });

                        html = html.add(element);
                    }
                }
            });
            return html;
        },
        operatorSearch: function () {
            var searchData = this.get('searchData'),
                operators = searchData ? searchData.get('operators') : false;

            return operators && operators.length ? operators.length : false;
        },
        operatorClearEnabled: function () {
            var changedFiltersPropose = this.get('changedFiltersPropose'),
                operatorSearch = this.get('operatorSearch');

            return !!(_.isEmpty(changedFiltersPropose) && operatorSearch);
        },
        nothingFoundDescription: function () {
            var searchData = this.get('searchData'),
                fromCity = searchData.get('departureCity') !== null ? searchData.get('departureCity').get('name') : '',
                toCountry = searchData.get('countries') !== null ? searchData.get('countries').at(0).get('name') : '',
                resorts = searchData.get('resorts') !== null ? searchData.get('resorts').pluck('name') : '',
                hotels = searchData.get('hotels') !== null ? searchData.get('hotels').pluck('name') : '',
                nightsFrom = searchData.get('nightRange') !== null ? searchData.get('nightRange').get('from') : '',
                nightsTo = searchData.get('nightRange') !== null ? searchData.get('nightRange').get('to') : '',
                dateFrom = searchData.get('checkInDateRange') !== null ? $.datepicker.formatDate("dd.mm", searchData.get('checkInDateRange').get('from')) : '',
                dateTo = searchData.get('checkInDateRange') !== null ? $.datepicker.formatDate("dd.mm", searchData.get('checkInDateRange').get('to')) : '',
                adults = searchData.get('touristGroup') ? searchData.get('touristGroup').get('adults') : '',
                kids = searchData.get('touristGroup') !== null ? searchData.get('touristGroup').get('kids') : '',
                infants = searchData.get('touristGroup') !== null ? searchData.get('touristGroup').get('infants') : '',
                budgetFrom = searchData.get('priceRange') !== null ? searchData.get('priceRange').get('from') : '',
                budgetTo = searchData.get('priceRange') !== null ? searchData.get('priceRange').get('to') : '',
                hotelClass = searchData.get('hotelCategories') !== null ? searchData.get('hotelCategories').pluck('name') : '',
                meal = searchData.get('meals') !== null ? searchData.get('meals').pluck('code') : '',
                comments = '';

            if (fromCity && toCountry) {
                comments += 'Из: ' + fromCity + ' в ' + toCountry + '\n';
            }

            if (resorts.length) {
                comments += 'Курорты: ' + resorts.join(', ') + '\n';
            }

            if (hotels.length) {
                comments += 'Отели: ' + hotels.join(', ') + '\n';
            }

            if (nightsFrom && nightsTo) {
                comments += 'Длительность: ' + nightsFrom + (nightsFrom === nightsTo ? '' : ' - ' + nightsTo ) + ' ночей\n';
            }

            if (adults) {
                comments += 'Кто едет: ' + adults + ' взрослых';

                if (kids !== 0) {
                    comments += ' и ' + kids + ' детей';
                }
                if (infants !== 0) {
                    comments += ' и ' + infants + ' младенцев';
                }

                comments += '\n';
            }

            if (dateFrom) {
                comments += 'Дата вылета: c ' + dateFrom + ' по ' + dateTo + '\n';
            }

            if (hotelClass) {
                comments += 'Класс отеля: ' + (hotelClass && hotelClass.length ? hotelClass.join(', ') : 'Любой') + '\n';
            }

            if (meal) {
                comments += 'Питание: ' + (meal && meal.length ? meal.join(', ') : 'Любое') + '\n';
            }

            comments += 'Бюджет ';
            if (budgetFrom) {
                comments += 'от ' + budgetFrom + ' руб. ';
            }
            if (budgetTo) {
                comments += 'до ' + budgetTo + ' руб. ';
            }
            comments += '\n';

            return comments;
        },
        showSortPannelWhenScroll: function () {
            // earlybooking
            var navbar = $('.searchContainer_navbar');

            if (navbar.length) {
                return (this.get('scrollPosition') > (navbar.offset().top));
            }

            return false;
        },
        filteredHotelsWithoutAttrs: function () {
            var hotels = this.get('syncHotels') ? this.get('syncHotels').models : [];
            hotels = this.filterByBeachType(hotels);
            hotels = this.filterByRating(hotels);
            hotels = this.filterByRatingNoScore(hotels);
            hotels = this.filterByRatingByLocation(hotels);
            hotels = this.filterByRatingByService(hotels);
            hotels = this.filterByRatingByMeal(hotels);
            hotels = this.filterByPrice(hotels);
            hotels = this.filterByBeachLine(hotels);
            hotels = this.filterByOperator(hotels);
            hotels = this.filterByFreeCancellation(hotels);
            return hotels;
        },
        filteredHotelsWithoutRating: function () {
            var hotels = this.get('syncHotels') ? this.get('syncHotels').models : [];
            hotels = this.filterByBeachType(hotels);
            hotels = this.filterByAttrs(hotels);
            hotels = this.filterByPrice(hotels);
            hotels = this.filterByBeachLine(hotels);
            hotels = this.filterByOperator(hotels);
            hotels = this.filterByRatingNoScore(hotels);
            hotels = this.filterByRatingByLocation(hotels);
            hotels = this.filterByRatingByService(hotels);
            hotels = this.filterByRatingByMeal(hotels);
            hotels = this.filterByFreeCancellation(hotels);
            return hotels;
        },
        filteredHotelsWithoutRatingByLocation: function () {
            var hotels = this.get('syncHotels') ? this.get('syncHotels').models : [];
            hotels = this.filterByBeachType(hotels);
            hotels = this.filterByAttrs(hotels);
            hotels = this.filterByPrice(hotels);
            hotels = this.filterByBeachLine(hotels);
            hotels = this.filterByOperator(hotels);
            hotels = this.filterByRatingNoScore(hotels);
            hotels = this.filterByRatingByService(hotels);
            hotels = this.filterByRatingByMeal(hotels);
            hotels = this.filterByFreeCancellation(hotels);
            return hotels;
        },
        filteredHotelsWithoutRatingByService: function () {
            var hotels = this.get('syncHotels') ? this.get('syncHotels').models : [];
            hotels = this.filterByBeachType(hotels);
            hotels = this.filterByAttrs(hotels);
            hotels = this.filterByPrice(hotels);
            hotels = this.filterByBeachLine(hotels);
            hotels = this.filterByOperator(hotels);
            hotels = this.filterByRatingNoScore(hotels);
            hotels = this.filterByRatingByLocation(hotels);
            hotels = this.filterByRatingByMeal(hotels);
            hotels = this.filterByFreeCancellation(hotels);
            return hotels;
        },
        filteredHotelsWithoutBeachLine: function () {
            var hotels = this.get('syncHotels') ? this.get('syncHotels').models : [];
            hotels = this.filterByBeachType(hotels);
            hotels = this.filterByAttrs(hotels);
            hotels = this.filterByPrice(hotels);
            hotels = this.filterByOperator(hotels);
            hotels = this.filterByRating(hotels);
            hotels = this.filterByRatingNoScore(hotels);
            hotels = this.filterByRatingByLocation(hotels);
            hotels = this.filterByRatingByService(hotels);
            hotels = this.filterByRatingByMeal(hotels);
            hotels = this.filterByFreeCancellation(hotels);
            return hotels;
        },
        filteredHotelsWithoutRatingByMeal: function () {
            var hotels = this.get('syncHotels') ? this.get('syncHotels').models : [];
            hotels = this.filterByBeachType(hotels);
            hotels = this.filterByAttrs(hotels);
            hotels = this.filterByPrice(hotels);
            hotels = this.filterByBeachLine(hotels);
            hotels = this.filterByOperator(hotels);
            hotels = this.filterByRatingNoScore(hotels);
            hotels = this.filterByRatingByService(hotels);
            hotels = this.filterByRatingByLocation(hotels);
            hotels = this.filterByFreeCancellation(hotels);
            return hotels;
        },
        filteredHotelsWithoutBeachType: function () {
            var hotels = this.get('syncHotels') ? this.get('syncHotels').models : [];
            hotels = this.filterByAttrs(hotels);
            hotels = this.filterByRating(hotels);
            hotels = this.filterByPrice(hotels);
            hotels = this.filterByBeachLine(hotels);
            hotels = this.filterByOperator(hotels);
            hotels = this.filterByRatingNoScore(hotels);
            hotels = this.filterByRatingByLocation(hotels);
            hotels = this.filterByRatingByService(hotels);
            hotels = this.filterByRatingByMeal(hotels);
            hotels = this.filterByFreeCancellation(hotels);
            return hotels;
        },
        filteredHotelsWithoutPrice: function () {
            var hotels = this.get('syncHotels') ? this.get('syncHotels').models : [],
                minPrice = Infinity,
                maxPrice = 0;
            if (!_.isEmpty(hotels)) {
                _.each(hotels, function (hotel) {
                    var price = hotel.get("priceWithOilTax");
                    if (price < minPrice) {
                        minPrice = price;
                    }

                    if (price > maxPrice) {
                        maxPrice = price;
                    }

                });
            }
            this.set('unfilteredMinPrice', minPrice);
            this.set('unfilteredMaxPrice', maxPrice);

            hotels = this.filterByBeachType(hotels);
            hotels = this.filterByAttrs(hotels);
            hotels = this.filterByRating(hotels);
            hotels = this.filterByBeachLine(hotels);
            hotels = this.filterByOperator(hotels);
            hotels = this.filterByRatingNoScore(hotels);
            hotels = this.filterByRatingByLocation(hotels);
            hotels = this.filterByRatingByService(hotels);
            hotels = this.filterByRatingByMeal(hotels);
            return hotels;
        },
        filteredHotelsWithoutOperator: function () {
            var hotels = this.get('syncHotels') ? this.get('syncHotels').models : [];
            hotels = this.filterByBeachType(hotels);
            hotels = this.filterByAttrs(hotels);
            hotels = this.filterByRating(hotels);
            hotels = this.filterByBeachLine(hotels);
            hotels = this.filterByRatingNoScore(hotels);
            hotels = this.filterByRatingByLocation(hotels);
            hotels = this.filterByRatingByService(hotels);
            hotels = this.filterByRatingByMeal(hotels);
            hotels = this.filterByPrice(hotels);
            return hotels;
        },

        filteredHotels: function () {
            var hotels = this.get('filteredHotelsWithoutRating') ? this.get('filteredHotelsWithoutRating') : [];
            hotels = this.filterByRating(hotels);
            return new this.HotelsSortedRepository(hotels);
        },
        filteredHotelsWithoutRatingByLocationChange:  {
            deps: ['filteredHotelsWithoutRatingByLocation'],
            get: function(filteredHotelsWithoutRatingByLocation) {
                var hotels = filteredHotelsWithoutRatingByLocation ? filteredHotelsWithoutRatingByLocation : [],
                    ratingByLocationCount = 0,
                    maxRating = 0;

                if (!_.isEmpty(hotels)) {
                    _.each(hotels, function (hotel) {
                        var ratingLocation = hotel.get('ratingDetails') ? hotel.get('ratingDetails').hotel : false;
                        if (ratingLocation) {
                            ratingByLocationCount++;
                            if (ratingLocation > maxRating) {
                                maxRating = Math.round(ratingLocation);
                            }
                        }
                    });
                }
                this.set('ratingByLocationCount', ratingByLocationCount);
                this.set('ratingLocationMax', maxRating);
            }

        },
        filteredHotelsWithoutBeachLineChange: function() {
            var hotels = this.get('filteredHotelsWithoutBeachLine') ? this.get('filteredHotelsWithoutBeachLine') : [],
                firstLineCount = 0,
                secondLineCount = 0,
                thirdLineCount = 0,
                beachLine;

            if (!_.isEmpty(hotels)) {
                _.each(hotels, function (hotel) {
                    beachLine = hotel.get('beachLine');

                    switch(beachLine) {
                        case '1':
                            firstLineCount++;
                            break;
                        case '2':
                            secondLineCount++;
                            break;
                        case '3':
                            thirdLineCount++
                    }
                });
            }
            this.set('firstLineCount', firstLineCount);
            this.set('secondLineCount', secondLineCount);
            this.set('thirdLineCount', thirdLineCount);
        },
        filteredHotelsWithoutRatingByServiceChange: function () {
            var hotels = this.get('filteredHotelsWithoutRatingByService') ? this.get('filteredHotelsWithoutRatingByService') : [],
                ratingByServiceCount = 0,
                maxRating = 0;

            if (!_.isEmpty(hotels)) {
                _.each(hotels, function (hotel) {
                    var ratingService = hotel.get('ratingDetails') ? hotel.get('ratingDetails').service : false;
                    if (ratingService) {
                        ratingByServiceCount++;
                    }
                    if (ratingService > maxRating) {
                        maxRating = Math.round(ratingService);
                    }
                });
            }
            this.set('ratingByServiceCount', ratingByServiceCount);
            this.set('ratingServiceMax', maxRating);
        },
        filteredHotelsWithoutRatingByMealChange: function () {
            var hotels = this.get('filteredHotelsWithoutRatingByMeal') ? this.get('filteredHotelsWithoutRatingByMeal') : [],
                ratingByMealCount = 0,
                maxRating = 0;
            if (!_.isEmpty(hotels)) {
                _.each(hotels, function (hotel) {
                    var ratingMeal = hotel.get('ratingDetails') ? hotel.get('ratingDetails').meal : false;
                    if (ratingMeal) {
                        ratingByMealCount++;
                    }
                    if (ratingMeal > maxRating) {
                        maxRating = Math.round(ratingMeal);
                    }
                });
            }
            this.set('ratingByMealCount', ratingByMealCount);
            this.set('ratingMealMax', maxRating);
        },
        filteredHotelsWithoutRatingChange: function () {
            var hotels = this.get('filteredHotelsWithoutRating') ? this.get('filteredHotelsWithoutRating') : [],
                rating,
                bestCount = 0,
                betterCount = 0,
                goodCount = 0,
                satisfactorilyCount = 0,
                noScoreCount = 0,
                allScoreCount = 0;

            if (!_.isEmpty(hotels)) {
                _.each(hotels, function (hotel) {
                    rating = Math.round(hotel.get('rating')*10)/10;

                    if (rating >= 4.5) {
                        bestCount++;
                    } else if (rating >= 4) {
                        betterCount++;
                    } else if (rating >= 3.5) {
                        goodCount++;
                    } else if (rating >= 3.0) {
                        satisfactorilyCount++;
                    } else if (!rating) {
                        noScoreCount++;
                    }
                    allScoreCount++;
                });
            }


            this.set('bestCount', bestCount);
            this.set('betterCount', betterCount);
            this.set('goodCount', goodCount);
            this.set('satisfactorilyCount', satisfactorilyCount);
            this.set('noScoreCount', noScoreCount);
            this.set('allScoreCount', allScoreCount);
        },
        filteredHotelsWithoutBeachTypeChange: function () {
            var hotels = this.get('filteredHotelsWithoutBeachType') ? this.get('filteredHotelsWithoutBeachType') : [],
                sandBeachCount = 0,
                pebbleBeachCount = 0;
            if (!_.isEmpty(hotels)) {
                _.each(hotels, function (hotel) {
                    hotel.get('sandBeach') ? sandBeachCount++ : 0;
                    hotel.get('pebbleBeach') ? pebbleBeachCount++ : 0;
                });
            }
            this.set('sandBeachCount', sandBeachCount);
            this.set('pebbleBeachCount', pebbleBeachCount);
        },

        filteredSimilarHotels: function () {
            var hotels = [],
                self = this,
				filteredHotels = this.get('filteredHotels'),
				covidBanner = this.get('covidBanner'),
                similarHotels = this.get('similarHotels');

            if (this.get('loadingState') == 'finished' && filteredHotels !== null && filteredHotels.length == 0) {
				if (covidBanner) {
					if (self.hotelsCollection?.length) {
						self.hotelsCollection.reset();
						return;
					}
				}
				if (similarHotels && self.hotelsCollection) {
                    hotels = similarHotels.models;
                    self.hotelsCollection.reset(similarHotels.models);
                    self.getHotelImages(similarHotels.models);
                }
            }

            return new this.HotelsSortedRepository(hotels);
        },
        filterCountsOverAll: function () {
            var hotels = this.get('syncHotels') ? this.get('syncHotels').models : [],
                rating,
                self = this,
                bestCountOverall = 0,
                betterCountOverall = 0,
                goodCountOverall = 0,
                satisfactorilyCountOverall = 0,
                allScoreCountOverall = 0,
                ratingByLocationCountOverall = 0,
                ratingByServiceCountOverall = 0,
                ratingByMealCountOverall = 0,
                noScoreCountOverall = 0,
                beachLine,
                firstLineCountOverall = 0,
                secondLineCountOverall = 0,
                freeCancellationCount = 0,
                thirdLineCountOverall = 0;


            self.resetCountersToZero();
            if (hotels.length) {
                _.each(hotels, function (hotel) {
                    rating = Math.round(hotel.get('rating')*10)/10;

                    if (rating >= 4.5) {
                        bestCountOverall++;
                    } else if (rating >= 4) {
                        betterCountOverall++;
                    } else if (rating >= 3.5) {
                        goodCountOverall++;
                    } else if (rating >= 3.0) {
                        satisfactorilyCountOverall++;
                    } else if (!rating) {
                        noScoreCountOverall++;
                    }

                    allScoreCountOverall++;

                    beachLine = hotel.get('beachLine');

                    switch(beachLine) {
                        case '1':
                            firstLineCountOverall++;
                            break;
                        case '2':
                            secondLineCountOverall++;
                            break;
                        case '3':
                            thirdLineCountOverall++;
                    }

                    var ratingByLocation = hotel.get('ratingDetails') ? hotel.get('ratingDetails').hotel : false;
                    if (ratingByLocation) {
                        ratingByLocationCountOverall++;
                    }
                    var ratingByService = hotel.get('ratingDetails') ? hotel.get('ratingDetails').service : false;
                    if (ratingByService) {
                        ratingByServiceCountOverall++;
                    }
                    var ratingByMeal = hotel.get('ratingDetails') ? hotel.get('ratingDetails').meal : false;
                    if (ratingByMeal) {
                        ratingByMealCountOverall++;
                    }
                    _.each(filtersCount, function (value, key) {
                        hotel.get(key) ? filtersCount[key]++ : 0;
                    });

                    const tourProducts = hotel.get("tourProducts");
                    if (tourProducts?.at(0)?.get("tour")?.get('freeCancellation')) {
                        freeCancellationCount++
                    }
                });
            }

            _.each(filtersCount, function (value, key) {
                self.set(key + 'CountOverall', filtersCount[key]);
            });

            this.set('bestCountOverall', bestCountOverall);
            this.set('betterCountOverall', betterCountOverall);
            this.set('goodCountOverall', goodCountOverall);
            this.set('satisfactorilyCountOverall', satisfactorilyCountOverall);
            this.set('noScoreCountOverall', noScoreCountOverall);
            this.set('allScoreCountOverall', allScoreCountOverall);

            this.set('ratingByLocationCountOverall', ratingByLocationCountOverall);
            this.set('ratingByServiceCountOverall', ratingByServiceCountOverall);
            this.set('ratingByMealCountOverall', ratingByMealCountOverall);


            this.set('firstLineCountOverall', firstLineCountOverall);
            this.set('secondLineCountOverall', secondLineCountOverall);
            this.set('thirdLineCountOverall', thirdLineCountOverall);

            this.set('freeCancellationCount', freeCancellationCount);

            return false;
        },
        minPriceSyncHotels: function () {
            var hotels = this.get('syncHotels'),
                minPrice = Infinity;

            if (hotels && hotels.length) {
                hotels.each(function (hotel) {
                    var price = hotel.get('minPrice');
                    if (price < minPrice) {
                        minPrice = price;
                    }
                });
                console.log('minPriceSyncHotels', minPrice);
                return minPrice;
            } else {
                return false;
            }
        },
        minPriceAsyncHotels: function () {
            var hotels = this.get('asyncHotels'),
                minPrice = Infinity;

            if (hotels && hotels.length) {
                _.each(hotels, function (hotel) {
                    var price = hotel.get('minPrice');
                    if (price < minPrice) {
                        minPrice = price;
                    }
                });
                console.log('minPriceAsyncHotels', minPrice);
                return minPrice;
            } else {
                return false;
            }
        },
        newResultPriceDifference: function () {
            var minPriceSync = this.get('minPriceSyncHotels'),
                minPriceAsync = this.get('minPriceAsyncHotels'),
                priceDifference;

            if (minPriceSync > 0 && minPriceAsync > 0 && minPriceAsync <= minPriceSync - 1000) {
                priceDifference = minPriceSync - minPriceAsync;
                console.log('newResultPriceDifference', priceDifference);
                return priceDifference;
            } else {
                return false;
            }
        },
        toursLeftText: function () {
            var numOfHotelsPerPage = 10,
                pageNumber = this.get('pageNumber'),
                hotels = this.get('filteredHotels'),
                hotelsLeft,
                hotelsLeftNumber,
                maxPages;

            if (hotels && hotels.length) {
                maxPages = Math.ceil(hotels.length / numOfHotelsPerPage);

                hotelsLeft = hotels.length - (pageNumber * numOfHotelsPerPage);
                hotelsLeftNumber = hotelsLeft > numOfHotelsPerPage ? numOfHotelsPerPage : hotelsLeft;


                if (pageNumber <= maxPages) {
                    return hotelsLeftNumber + ' отел' + hotelsLeftNumber.wordEnding('ь;я;ей');
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        pageIncAvaliable: function () {
            var numOfHotelsPerPage = 10,
                pageNumber = this.get('pageNumber'),
                hotels = this.get('filteredHotels'),
                maxPages;

            if (hotels && hotels.length) {
                maxPages = Math.ceil(hotels.length / numOfHotelsPerPage);

                if (pageNumber < maxPages) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },

        enableFilters: function () {
            var syncHotels = this.get('syncHotels');
            return syncHotels && syncHotels.length;

        },
        fromCityLabel: function () {
            if (this.get('searchData').get('departureCity') !== null) {
                return this.get('searchData').get('departureCity').get('name');
            } else {
                return false;
            }
        },
        toCountryFlag: function () {
            if (this.get('searchData').get('countries') !== null) {
                return 'flagIco flag_' + this.get('searchData').get('countries').at(0).get('id');
            } else {
                return false;
            }
        },
        toCountryLabel: function () {
            if (this.get('searchData').get('countries') !== null) {
                return this.get('searchData').get('countries').pluck('name').slice(0, 3).join(', ');
            } else {
                return false;
            }
		},
		toCountryFromCity: {
			deps: ['toCountryLabel', 'fromCityLabel'],
			get: (toCountryLabel, fromCityLabel) => {
				const { toCountryName = '', departureCity = { nameFrom: '' } } = window.appConfig;

				if (!toCountryLabel && !fromCityLabel) return `Туры ${toCountryName} ${departureCity.nameFrom}`;
				if(!toCountryLabel && fromCityLabel) return `Туры ${toCountryName} ${fromCityLabel}`;
				if(toCountryLabel && !fromCityLabel) return `Туры ${toCountryLabel} ${departureCity.nameFrom}`;

				return `${toCountryLabel} ${fromCityLabel}`
			}

        },
        resortsLabel: function () {
            if (this.get('searchData').get('resorts') !== null && this.get('searchData').get('resorts').length) {
                return this.get('searchData').get('resorts').pluck('name').slice(0, 4).join(', ');
            } else {
                return false;
            }
        },
        hotelCategoriesLabel: function () {
            if (this.get('searchData').get('hotelCategories') !== null && this.get('searchData').get('hotelCategories').length) {
                return this.get('searchData').get('hotelCategories').pluck('name').join(', ');
            } else {
                return false;
            }
        },
        mealsLabel: function () {
            if (this.get('searchData').get('meals') !== null && this.get('searchData').get('meals').length) {
                return this.get('searchData').get('meals').pluck('code').join(', ');
            } else {
                return false;
            }
        },
        mealsLabelExtend: function () {
            var label = [];

            if (this.get('searchData').get('meals') !== null && this.get('searchData').get('meals').length) {
                this.get('searchData').get('meals').each(function (meal) {
                    label.push('<span title="' + meal.get('name') + '">' + meal.get('code') + '<span class="mealsHelpBlock"> - ' + meal.get('name') + '</span></span>');
                });
                return label.join(', ');
            } else {
                return false;
            }
        },
        mealsLabelSmart: function () {
            var label = [];
            if (this.get('searchData').get('meals') !== null) {
                var mealsCount = this.get('searchData').get('meals').length;
                this.get('searchData').get('meals').each(function (meal) {
                    if (mealsCount == 1) {
                        label.push('<span title="' + meal.get('name') + '">' + meal.get('code') + '<span class="mealsHelpBlock"> - ' + meal.get('name') + '</span></span>');
                    } else {
                        label.push('<span title="' + meal.get('name') + '">' + meal.get('code') + '</span>');
                    }
                });
                return label.join(', ');
            } else {
                return false;
            }
        },
        hotelsLabel: function () {
            if (this.get('searchData').get('hotels') !== null) {
                if (this.get('searchData').get('hotels').length) {
                    return this.get('searchData').get('hotels').pluck('name').slice(0, 2).join(', ');
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        dateLabel: function () {
            var from, to;
            if (this.get('searchData').get('checkInDateRange') !== null) {
                var from = this.get('searchData').get('checkInDateRange').get('from'),
                    to = this.get('searchData').get('checkInDateRange').get('to');

                return from.getTime() != to.getTime() ? 'с ' + $.datepicker.formatDate("dd.mm", from) + ' по ' + $.datepicker.formatDate("dd.mm", to) : $.datepicker.formatDate("dd.mm", from);
            } else {
                return false;

            }
        },
        nightsLabelOriginal: function () {
            var from, to;
            if (this.get('searchData').get('nightRange') !== null) {
                from = this.get('searchData').get('nightRange').get('from');
                to = this.get('searchData').get('nightRange').get('to');

                return from != to ? ('на ' + from + '-' + to + ' ноч' + to.wordEnding('ь;и;ей')) : (to + ' ноч' + to.wordEnding('ь;и;ей'));
            } else {
                return false;
            }
        },
        nightsLabel: function () {
            var nightsChanged = _.contains(tourCriteriaService.getTourCriteriaChangedFields(), 'nightRange'),
                nightsLabelOriginal = this.get('nightsLabelOriginal');

            if (nightsLabelOriginal && nightsChanged) {
                return nightsLabelOriginal;
            } else {
                return false;
            }
        },
        budgetLabel: function () {
            var from, to,
                budgetChanged = _.contains(tourCriteriaService.getTourCriteriaChangedFields(), 'priceRange');

            if (this.get('searchData').get('priceRange') && budgetChanged) {
                var from = this.get('searchData').get('priceRange').get('from'),
                    to = this.get('searchData').get('priceRange').get('to');

                return from != to ? (from.formatNumber() + '<span class="rubl">a</span> - ' + to.formatNumber() + ' <span class="rubl">a</span>') : (from.formatNumber() + '<span class="rubl">a</span>');
            } else {
                return false;

            }
        },
        adults: function () {
            if (this.get('searchData').get('touristGroup') !== null) {
                return this.get('searchData').get('touristGroup').get('adults');
            } else {
                return false;
            }
        },
        kids: function () {
            if (this.get('searchData').get('touristGroup') !== null) {
                return this.get('searchData').get('touristGroup').get('kids');
            } else {
                return false;
            }
        },
        infants: function () {
            var infants,
                touristGroup = this.get('searchData').get('touristGroup');
            if (touristGroup !== null) {
                infants = touristGroup.get('infants');
                return infants ? infants : 0;
            } else {
                return false;
            }
        },
        totalKids: {
            deps: ['kids', 'infants'],
            get (kids, infants) {
                return kids + infants;
            },
        },
        totalKidsLabel: {
            deps: ['kids', 'infants', 'totalKids'],
            get (kids, infants, totalKids) {
                if (!kids && infants) {
                    return `${totalKids} ${totalKids?.wordEnding('младенца;младенцев;младенцев')}`
                }

                return `${totalKids} ${totalKids?.wordEnding('ребенка;детей;детей')}`
            },
        },
        adultsLabel: function () {
            if (this.get('searchData').get('touristGroup') !== null) {
                return this.get('searchData').get('touristGroup').get('adults');
            } else {
                return false;
            }
        },
        kidsLabel: function () {
            var kids = this.get('kids');
            return kids ? kids : "-";
        },
        infantLabel: function () {
            var infants = this.get('infants');
            return infants ? infants : "-";
        },
        numOfToursFound: function () {
            var products = this.get('syncTourProducts');
            if (products !== null && products.length > 0) {
                return products.length;
            } else {
                return false;
            }
        },
        numOfHotelsFound: function () {
            var hotels = this.get('syncHotels');

            if (hotels !== null && hotels.length > 0) {
                var currentTourCriteria = this.get('searchData');

                if (currentTourCriteria && currentTourCriteria.get('countries') && currentTourCriteria.get('resorts') && typeof (window.APRT_SEND) !== "undefined") {
                    var firstTourProduct = hotels.at(0).get('tourProducts').at(0),
                        departureCity = currentTourCriteria.get('departureCity').get('name'),
                        country = currentTourCriteria.get('countries').at(0).get('name'),
                        resorts = currentTourCriteria.get('resorts'),
                        resortModel = resorts && resorts.at(0) || null,
                        resortName = resortModel && resortModel.get('name') || null,
                        categories = currentTourCriteria.get('hotelCategories'),
                        classModel = categories.length && categories.min(function (element) {
                            return element.get('stars')
                        }) || null,
                        classId = classModel && classModel.get('stars') || 0,
                        tourists = firstTourProduct.get('tour').get('touristGroup'),
                        nbra = parseInt(tourists.adults),
                        nbrc = tourists.kids,
                        nbri = tourists.infants || 0,
                        checkin_date = moment(currentTourCriteria.get('checkInDateRange').get('from')).format('YYYY-MM-DD'),
                        checkout_date = moment(currentTourCriteria.get('checkInDateRange').get('to')).format('YYYY-MM-DD');


                    var params = {
                        pageType: 3,
                        searchTickets: {
                            type: 'hotel',
                            class: classId,
                            from: departureCity,
                            country,
                            dateFrom: checkin_date,
                            dateTill: checkout_date,
                            count: nbra,
                            countChildren: nbrc,
                            countBaby: nbri,
                        },
                    };
                    if (resortName) {
                        params.dest = resortName;
                    }
                    window.APRT_SEND(params);
                }
                return hotels.length;
            }
            return false;
        },
        numOfHotelsFiltered: function () {
            if (this.get('filteredHotels') !== null) {
                return this.get('filteredHotels').length;
            } else {
                return false;
            }
        },
        additionalToursFound: function () {
            var newTours,
                syncTourProducts = this.get('syncTourProducts'),
                asyncTourProducts = this.get('asyncTourProducts');

            if (syncTourProducts !== null && asyncTourProducts !== null) {
                newTours = asyncTourProducts.length - syncTourProducts.length;
                if (newTours > 0) {
                    return newTours;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        additionalHotelsFound: function () {
            var newHotels,
                syncHotels = this.get('syncHotels'),
                asyncHotels = this.get('asyncHotels');

            if (syncHotels !== null && asyncHotels !== null) {
                newHotels = asyncHotels.length - syncHotels.length;
                if (newHotels >= syncHotels.length * 0.1) {
                    return newHotels;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    },
    quantityField:'toursQuantity'
})
export default class SearchPageModel extends Backbone.Epoxy.Model {

    closeEmptySearchBanners() {
        // скрываем все попапы дополнительных посиков при любом начальном поиске
        console.warn("Запущен новый поиск, скрываем все баннеры");
        this.set({
            goSearchEmptySerpFoundByAnotherDate: null,
            foundByAnotherDate: null,
            callMeBackBannerVisible: null,
            additionalSearch: null,
            searchByDefaultTourCriteria: null,
            visibleSimilarTours: null
        });

    }

    filterByAttrs(hotels) {
        var filters = this.get('filterCriteria');
        _.each(filterNames, function (filterName) {
            if (filters.get(filterName)) {
                hotels = _.filter(hotels, function (hotel) {
                    return hotel.get(filterName) === true;
                });
            }
        });

        return hotels;
    }

    filterByBeachType(hotels) {
        var filters = this.get('filterCriteria');
        if (filters.get('beachType')) {
            var attr = filters.get('beachType');
            hotels = _.filter(hotels, function (hotel) {
                return hotel.get(attr) === true;
            });
        }
        return hotels.slice(0);
    }

    filterByOperator(hotels) {
        const operators = this.get('filterCriteria').get('operators');
		if(!operators.length) return hotels;
		return hotels.reduce((acc, hotel) => {
			const tourProducts = hotel.get('tourProducts').filter((tourProduct) => operators.includes(tourProduct.get('tour').get('operator').id));
			if(tourProducts.length) {
				const clonedHotel = hotel.clone();
				clonedHotel.set('tourProducts', new Backbone.Collection(tourProducts));
				clonedHotel.initHotelOptions();
				acc.push(clonedHotel);
			}
			return acc;
		}, []);
    }

    // эти методы определяет public/travelata/v2/js/modules/atlas/View/SearchPageReviews.js
    filterByRatingNoScore(hotels) {
       return hotels;
    }

    filterByRatingByLocation(hotels) {
       return hotels;
    }

    filterByRatingByService(hotels) {
       return hotels;
    }

    filterByRatingByMeal(hotels) {
       return hotels;
    }

    // конец методов для SearchPageReviews.js
    filterByRating(hotels) {
        var filters = this.get('filterCriteria'),
            bestScoreActive = filters.get('best'),
            betterScoreActive = filters.get('better'),
            goodScoreActive = filters.get('good'),
            satisfactorilyActive = filters.get('satisfactorily'),
            noScoreActive = filters.get('noScore');

        if(bestScoreActive || betterScoreActive || goodScoreActive || satisfactorilyActive || noScoreActive) {
            hotels = _.filter(hotels, (hotel) => {
                const rating = Math.round(hotel.get('rating') * 10) / 10;

                return (bestScoreActive && rating >= 4.5)
                    || (betterScoreActive && rating >= 4)
                    || (goodScoreActive && rating >= 3.5)
                    || (satisfactorilyActive && rating >= 3)
                    || (noScoreActive && !rating);
            });
        }

        return hotels.slice(0);
    }

    filterByBeachLine(hotels) {
        var filters = this.get('filterCriteria'),
            firstLine = filters.get('firstLine'),
            secondLine = filters.get('secondLine'),
            thirdLine = filters.get('thirdLine');

        if (firstLine || secondLine || thirdLine) {
            hotels = _.filter(hotels, function (hotel) {
                var hotelBeachLine = hotel.get('beachLine');
                return (firstLine && hotelBeachLine === "1") ||
                    (secondLine && hotelBeachLine === "2") ||
                    (thirdLine && hotelBeachLine === "3");
            });
        }
        return hotels.slice(0);
    }

    filterByPrice(hotels) {
        var filters = this.get('filterCriteria');
        if (filters.get('minPrice')) {
            hotels = _.filter(hotels, function (hotel) {
                return hotel.get("priceWithOilTax") >= filters.get('minPrice');
            });
        }
        if (filters.get('maxPrice')) {
            hotels = _.filter(hotels, function (hotel) {
                return hotel.get("priceWithOilTax") <= filters.get('maxPrice');
            });
        }
        return hotels.slice(0);
    }

    filterByFreeCancellation(hotels) {
        const filters = this.get('filterCriteria');
        const freeCancellation = filters.get('freeCancellation');
        if (freeCancellation) {
            hotels = _.filter(hotels, item => item.get('tourProducts').at(0).get("tour").get('freeCancellation'));
        }
        return hotels.slice(0);
    }

    filteredHotelsChanged() {
        var hotels = this.get('filteredHotels') ? this.get('filteredHotels').models : [],
            self = this,
            numOfToursFiltered = 0,
			freeCancellationCount = 0,
            price,
            minPrice = Infinity,
            maxPrice = 0;

        self.resetCountersToZero();

        if (!_.isEmpty(hotels)) {
            _.each(hotels, function (hotel) {

                _.each(filtersCount, function (value, key) {
                    hotel.get(key) ? filtersCount[key]++ : 0;
                });

                price = hotel.get('priceWithOilTax');

                if (price < minPrice) {
                    minPrice = price;
                }

                if (price > maxPrice) {
                    maxPrice = price;
                }
                numOfToursFiltered += hotel.get(self.quantityField);

				const tourProducts = hotel.get("tourProducts");
					if (tourProducts?.at(0)?.get("tour")?.get('freeCancellation')) {
						freeCancellationCount++
					}
            });
        }

        this.set('minPrice', minPrice);
        this.set('maxPrice', maxPrice);
        this.set('numOfToursFiltered', numOfToursFiltered);
        this.set('freeCancellationCount', freeCancellationCount);

        _.each(filtersCount, function (value, key) {
            self.set(key + 'Count', filtersCount[key]);
        });

        if(self.hotelsCollection) {
            self.hotelsCollection ? self.hotelsCollection.reset() : '';
            this.set('pageNumber', 1, {silent: true});
            this.incCollection();

            var filtersValue = filterTitles.join(',');
            var formName = 'Search form serp';

            if (formName.length && filtersValue !== filtersValueOld) {
                filtersValueOld = filtersValue;
                if (filtersValue.length) gaAsync(function () {
                    ga('send', 'event', formName, 'criteria_comfort', filtersValue, {'nonInteraction': 1})
                });
            }

            if (formName.length && filterRatingTitle !== null && filterRatingTitle !== filterRatingValueOld) {
                filterRatingValueOld = filterRatingTitle;
                if (filterRatingTitle.length) gaAsync(function () {
                    ga('send', 'event', formName, 'criteria_reviews', filterRatingTitle, {'nonInteraction': 1})
                });
            }
        }
    }

    callECommerce(newHotels) {
        var collection = this.hotelsCollection;

        ecommerceService.impressions({
            collection:collection,
            hotels:newHotels,
            category:'tour',
            pageType:'serpTour',
            departureCityName:this.get("searchData").get('departureCity').get('name')
        });
    }

    incCollection() {
        this.systemInfoBenchmark?.startBench('serpToursProductsRenderTime');

        var numOfHotelsPerPage = 10,
			pageNumber = this.get('pageNumber'),
			covidBanner = this.get('covidBanner'),
            hotels = this.get('filteredHotels'),
			addHotels;

		if (covidBanner) {
			if (this.hotelsCollection?.length) {
				this.hotelsCollection?.reset();
			}
			return;
		}

        if (hotels && hotels.length) {
            addHotels = hotels.models.slice((pageNumber - 1) * numOfHotelsPerPage, numOfHotelsPerPage * pageNumber);
            this.hotelsCollection.add(addHotels);
            this.getHotelImages(addHotels);
            this.callECommerce(addHotels);
        }

        this.systemInfoBenchmark?.stopBenchmarking('serpToursProductsRenderTime');
    }

    updateRenderedCollection() {
        console.time('updateRenderedCollection');
        var numOfHotelsPerPage = 10,
			pageNumber = this.get('pageNumber'),
			covidBanner = this.get('covidBanner'),
            hotels = this.get('filteredHotels'),
            renderedHotels;

		if (covidBanner) {
			if (this.hotelsCollection?.length) {
				this.hotelsCollection?.reset();
			}
			return;
		}

        if (hotels && hotels.length) {
            hotels.sort();
            renderedHotels = hotels.models.slice(0, numOfHotelsPerPage*pageNumber);
            this.hotelsCollection.reset(renderedHotels);
            this.getHotelImages(renderedHotels);
        }

        console.timeEnd('updateRenderedCollection');
    }

    getHotelImages(hotels) {
        var hotelIds;

        hotels = _.filter(hotels, function (hotel) {
            return hotel.get('imagesHtml') === null;
        });

        hotelIds = _.map(hotels, function (hotel) {
            hotel.set('imagesHtml', false);
            return hotel.get('id');
        });

        if (hotelIds.length) {
            getMultipleHotelPhotosService({hotels: hotelIds}, {
                success: function (data) {
                    _.each(hotels, function (hotel) {
                        var hotelId = hotel.get('id'),
                            hotelData = data[hotelId],
                            cover = hotelData.cover,
                            photos = hotelData.photos;

                        hotel.set('cover', cover, {silent: true});
                        hotel.set('photos', photos, {silent: true});
                        hotel.trigger('change:photos');
                    });
                },
                error: function () {
                    _.each(hotels, function (hotel) {
                        hotel.set('cover', false, {silent: true});
                        hotel.set('photos', false, {silent: true});
                        hotel.trigger('change:photos');
                    });
                }
            });
        }
    }

    initEvents() {
        var self = this,
            childrenFilters = {
                children_animators: false,
                children_pool: false,
                children_waterslides: false,
                children_aquapark: false,
                children_seaEnter: false,
                children_childmenu: false,
                children_childBed: false,
                children_nanny: false,
                children_clubs: false
            };
        self.on("change:searchData", function () {
            self.set("showChildrenFilters", self.get("searchData").get("touristGroup").get("kids") || self.get("searchData").get("touristGroup").get("infants"));
            if (!self.get("showChildrenFilters")) {
                for (var i in childrenFilters) {
                    self.filterCriteria.set(i, childrenFilters[i])
                }
            }

        });
        self.on("change:loadingState", function () {
            //if(value != "finished") return;
            var hotels = self.get('filteredHotels').models,
                hotelIds = [],
                currentTourCriteria = this.get('searchData');

            if (hotels.length) {
                var maxHotelIds = hotels.length < 5 ? hotels.length : 5;
                for (var i = 0; i < maxHotelIds; i++) {
                    hotelIds.push(hotels[i].get("id"))
                }
                if(window.setGlobalWindowCritea) {
                    setGlobalWindowCritea([
                        {
                            event: "viewList",
                            item: hotelIds
                        },
                        {
                            event: "viewSearch",
                            din: moment(currentTourCriteria.get('checkInDateRange').get('from')).format('YYYY-MM-DD'),
                            dout: moment(currentTourCriteria.get('checkInDateRange').get('to')).format('YYYY-MM-DD'),
                            nbra: parseInt(currentTourCriteria.get('touristGroup').get('adults')),
                            nbrc: parseInt(currentTourCriteria.get('touristGroup').get('kids')),
                            nbri: parseInt(currentTourCriteria.get('touristGroup').get('infants')),
                            nbrr: ""
                        }
                    ]);
                }
            }
        })
    }

    createAttrCounter() {
        var attributes = this.filterCriteria.toJSON(),
            notAttributes = ['beachType','minPrice','maxPrice','rating','operators','ratingLocation','ratingService','ratingMeal', 'firstLine', 'secondLine', 'thirdLine', 'best', 'better', 'good', 'satisfactorily', 'noScore', 'freeCancellation'],
            i;

        for(i in notAttributes){
            delete attributes[notAttributes[i]];
        }
        for(i in attributes){
            filtersCount[i] = 0;
            filterNames.push(i);
            this.set(i + "Count",0);
            this.set(i + "CountOverall",0);
        }
    }

    resetCountersToZero() {
        for(var i in filtersCount){
            filtersCount[i] = 0;
        }
    }

    initModelEvents() {

        this.on('change:pageNumber', $.proxy(this.incCollection, this));
        this.on('change:filteredHotels', $.proxy(this.filteredHotelsChanged, this));

    }

    initialize(options) {
        var self = this;
        this.hotelsCollection = options.hotelsCollection;
        this.filterCriteria = options.filterCriteria;
        this.searchFormViewModel = options.searchFormViewModel;
        this.systemInfoBenchmark = options.systemLogInfo;

        this.initEvents();
        this.initModelEvents();
        this.createAttrCounter();

        this.HotelsSortedRepository = HotelsSortedRepo.extend({
            comparator: function (model1, model2) {
                return this.strategies[self.get('sortStrategy')](model1, model2);
            }
        });
    }
}
